import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const CookieConsent = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("ak_cookie")) {
      const timer = setTimeout(() => setVisible(true), 1600);
      return () => clearTimeout(timer);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem("ak_cookie", value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[120] bg-card border border-gold/25 rounded-sm p-5 shadow-2xl"
        >
          <div className="flex items-start gap-3">
            <Cookie size={22} className="text-gold shrink-0 mt-0.5" />
            <div>
              <p className="text-sm text-foreground/80 font-sans leading-relaxed">{t("cookie.text")}</p>
              <Link to="/privacy" className="text-xs text-gold hover:underline font-sans">
                {t("cookie.learn")}
              </Link>
              <div className="mt-4 flex gap-3">
                <button
                  data-testid="cookie-accept"
                  onClick={() => choose("accepted")}
                  className="bg-gold text-black text-xs font-sans font-semibold uppercase tracking-widest px-5 py-2.5 rounded-sm hover:bg-gold-deep transition-colors"
                >
                  {t("cookie.accept")}
                </button>
                <button
                  data-testid="cookie-decline"
                  onClick={() => choose("declined")}
                  className="border border-border text-muted-foreground text-xs font-sans font-semibold uppercase tracking-widest px-5 py-2.5 rounded-sm hover:text-foreground transition-colors"
                >
                  {t("cookie.decline")}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
